module.exports = __webpack_public_path__ + "assets/landscape-flipped.b31b9ffc.svg";